import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { businessPlanQueryKeys } from '../businessPlan-qk';
import { BusinessPlanApi } from '../businessPlan.api';
import { IGetIndustryPictutesParams } from '../types';

export const useGetIndustryPictures = ({ type, enabled }: IGetIndustryPictutesParams) => {
  return useQuery({
    queryKey: businessPlanQueryKeys.businessPlanIndustryPictures(type),
    queryFn: () => BusinessPlanApi.getIndustryPictutes({ type }),
    enabled,

    placeholderData: keepPreviousData
  });
};
